export default __webpack_public_path__ + "static/media/cirec5.f35eeda7.png";